import Image from "next/image"
// import upscbanner1 from "../../assets/images/home/Banner/UPSC-CSE-2025-Webbanner.jpg";
// import phone from "../../assets/images/upsc/phone.png";
import downloadicon from "../../assets/images/download.png";
//import styles from "../upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
const Acheiver = dynamic(()=>import("../../components/our-acheiver/achievers"));
const BranchAddress = dynamic(()=>import("../../components/branch-address"));
const ObtionalButton = dynamic(()=>import("../../components/optionalbutton"));
import Classroom_form from "../sia-mentoring/upsc-ias-ips-admission-form";
import useDownloader from "react-use-downloader";
import Link from "next/link";
import Head from "next/head";
const UPSCClassroomOnline = () => {


    return (
      <>
              <Head>
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="noindex,nofollow" />
                <meta name="robots" content="noindex,nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <title>Students Mentoring Online Support  | Shankar IAS Academy</title>
                <link rel="canonical" href="https://www.shankariasacademy.com/sia-mentoring/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
              </Head>

<Navbar title="upsc" />

<Classroom_form branchname="Coimbatore"/>

      <Interest />
      <Footer />                        
      </>
    )
  }
  
  export default UPSCClassroomOnline;
